<script setup lang="ts">
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import SkeletonLoader from "@/components/SkeletonLoader.vue";
import Autoplay from "embla-carousel-autoplay";

type CarouselItemData = {
  path: string; // e.g., "/images/studio1.jpg"
  alt: string;
};

const props = defineProps({
  items: {
    type: Array as () => CarouselItemData[],
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <SkeletonLoader
    v-if="isLoading"
    class="w-full h-80 lg:h-[400px] xl:w-[544px] xl:h-[725px]"
  />
  <Carousel
    v-else
    :plugins="[
      Autoplay({
        delay: 3000,
      }),
    ]"
    class="relative w-full max-w-xl h-full max-h-[70vh] rounded-2xl shadow-xl overflow-hidden bg-zinc-800 dark:border-black"
  >
    <CarouselContent class="h-full">
      <CarouselItem
        v-for="(item, index) in props.items"
        :key="index"
        class="h-full"
      >
        <div class="h-full p-4">
          <img
            :src="item.path"
            :alt="item.alt"
            class="object-contain w-full h-auto max-h-[60vh]"
          />
        </div>
      </CarouselItem>
    </CarouselContent>

    <!-- Navigation Buttons -->
    <CarouselPrevious
      class="absolute z-10 hidden w-10 h-10 transition -translate-y-1/2 border border-gray-300 rounded-full shadow md:flex left-3 top-1/2 bg-white/80 hover:bg-white dark:bg-zinc-700 dark:hover:bg-zinc-600 dark:border-zinc-500"
    />
    <CarouselNext
      class="absolute z-10 hidden w-10 h-10 transition -translate-y-1/2 border border-gray-300 rounded-full shadow md:flex right-3 top-1/2 bg-white/80 hover:bg-white dark:bg-zinc-700 dark:hover:bg-zinc-600 dark:border-zinc-500"
    />
  </Carousel>
</template>
